import React from 'react';
import { ModalX } from '../../../BaseComponents';
import LoginForm from './Component';
const LoginFormModal = ({ modalProps, loginFormProps }) => {
    return (React.createElement(ModalX, Object.assign({ size: "medium" }, modalProps),
        React.createElement(LoginForm, Object.assign({}, loginFormProps))));
};
export default LoginFormModal;
